import React, {useState, useEffect, useContext, Fragment} from 'react'
import Layout from "components/sales/layout/layout";
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Link } from 'react-router-dom';

const ToolkitInspection = ({
    materialInspected,
    fetchMaterialInspection,
    fetchMaterialInspetionList
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [listData, setListData] = useState([]);
    const { baseUrl } = useContext(BaseUrl);
    const [materialInspect, setMaterialInspect] = useState(true);
    const headerBtns = () => {
        return (
            <Fragment>
            <Link
                to={`${baseUrl}/toolkit-inspection-form`}
                className="btn btn-primary d-md-inline-block"
                >
                Toolkit Form
                <img src={Images?.ArrowRight} alt="" />
            </Link>
            </Fragment>
          );
    }
    const headers = [
        'No. of Toolkits Inspected',
        'Inspection Report Date',
        'Action',
    ];

    useEffect(()=> {
        (async()=> {
            setIsLoading(true)
            const res = await materialInspected()
            if(res){
                setMaterialInspect(false)
            }
            setIsLoading(false)
        })();
    }, [])

    useEffect(()=> {
        (async()=> {
            setIsLoading(true)
            await fetchMaterialInspection()
            setIsLoading(false)
        })();
    }, [])

    useEffect(() => {
        const tableData = [
            'count_per_date',
            'inspection_date',
        ];
        
        if (fetchMaterialInspetionList && fetchMaterialInspetionList.length > 0) {
            const data = fetchMaterialInspetionList.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => ( 
                        {[key]: element[key]}
                        )
                    ),
                    {
                        Action: [
                          {
                            name: 'View Inspection',
                            link: `${baseUrl}/toolkit-inspection-view/${element.inspection_date}`,
                          }
                        ]
                      }
                )
            );  
            data && setListData(data);
        }
      }, [fetchMaterialInspetionList]);

    return(
        <Layout
            title="Toolkit Inspection Request"
            Buttons={materialInspect && headerBtns}
            isLoading={isLoading}
        >
            <TableSection
                data={listData}
                isId={false}
                isMngId={false}
                headers={headers}
            />

        </Layout>
    )

}

export default ToolkitInspection